import React, { PureComponent } from "react";
import "./profile.less";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import avatarIcon from "../../assets/profile_avatar.svg";
import settingIcon from "../../assets/setting_logo.svg";
import Section from "../../components/section/section";
import { withRouter } from "react-router";
import ChangePassword from "./changePassword";
import PersonalInfo from "./personalInfo";
import { isAdmin as checkAdmin } from "../../common/helpers";

@withRouter
@connect(({ session, localize }) => ({
  translate: getTranslate(localize),
}))
export default class Profile extends PureComponent {
  cunstructor() {
    this.state = {
      isAdmin: false,
    };
  }
  async componentDidMount() {
    window.scrollTo(0, 0);
    this.setState({ isAdmin: await checkAdmin() });
  }

  render() {
    const { isAdmin } = this.state || {};
    const { translate } = this.props;
    return (
      <>
        {!isAdmin && (
          <Section
            className={"profile"}
            title={translate("profile.title")}
            icon={avatarIcon}
          >
            <PersonalInfo />
          </Section>
        )}
        <Section
          className={"profile"}
          title={translate("profile.settings")}
          icon={settingIcon}
        >
          <ChangePassword />
        </Section>
      </>
    );
  }
}
